import type { FC } from "react";
import { Container, Row } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import {
  ContentDivider,
  StyledImageCol,
  StyledTextBodyRow,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";
import { Image, ImageSize } from "src/website-apps/shared/components/image";

interface GivingBackProps {
  readonly images: readonly string[];
}

export const GivingBack: FC<GivingBackProps> = ({ images }) => (
  <>
    <ContentDivider />

    <TextWrapper>
      <Container>
        <Row>
          <StyledTitle>
            <Content id="cid$#1907007#" />
          </StyledTitle>
        </Row>
        <Row>
          {images.map((image, index) => (
            <StyledImageCol key={index} span={[12, 12, 6, 3]}>
              <Image alt="Giving Back" src={image} size={ImageSize.Square6Col} />
            </StyledImageCol>
          ))}
        </Row>
        <StyledTextBodyRow>
          <Content id="cid$#1907008#" raw />
        </StyledTextBodyRow>
        <StyledTextBodyRow>
          <Content id="cid$#1907009#" raw />
        </StyledTextBodyRow>
      </Container>
    </TextWrapper>
  </>
);
